import Vue from "vue";
import StackOrderTable from "@/components/Stack/StackOrderTable.vue";
import StackOrderUpdateModal from "@/components/Stack/StackOrderUpdateModal.vue";
import { getStackOrders } from "@/services/stackOrderService";
import { mapGetters } from "vuex";
import StackOrderCreateModal from "@/components/Stack/StackOrderCreateModal.vue";
export default Vue.extend({
    components: {
        StackOrderTable,
        StackOrderUpdateModal,
        StackOrderCreateModal,
    },
    data() {
        return {
            stackOrders: [],
            stackOrder: {},
            copyStackOrder: undefined,
            stackOrderUpdateDialog: false,
            stackOrderCreateDialog: false,
            loading: false,
            searchFilter: "",
            showInactive: false,
        };
    },
    async mounted() {
        this.loadStackOrders();
    },
    computed: {
        ...mapGetters({ currentUser: "getLoggedInUser" }),
        activeStackOrders() {
            return this.stackOrders.filter((order) => order.isActive);
        },
        filteredStackOrders() {
            if (this.showInactive) {
                return this.stackOrders;
            }
            return this.activeStackOrders;
        },
    },
    methods: {
        async onRowClicked(order) {
            this.stackOrderUpdateDialog = true;
            this.stackOrder = order;
        },
        async onCreateStackOrder() {
            this.stackOrderCreateDialog = true;
        },
        async loadStackOrders() {
            this.loading = true;
            this.stackOrders = await getStackOrders();
            this.loading = false;
        },
        async onCopyStackOrder(stackorder) {
            this.copyStackOrder = stackorder;
            this.stackOrderCreateDialog = true;
            // Allow copy stack order to propogate, but reset after setting
            // to make sure copyStackorder to be used on create
            await this.$nextTick();
            this.copyStackOrder = undefined;
        },
    },
});
